"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kybScreenCreateProfileSchema = exports.kybScreenSearchSchema = void 0;
const zod_1 = require("zod");
exports.kybScreenSearchSchema = zod_1.z
    .object({
    name: zod_1.z.string().trim().min(1).max(200),
    country_code: zod_1.z
        .string()
        .trim()
        .regex(/^[A-Z]{2}$/u, 'country_code must be ISO 3166-1 alpha-2'),
    city: zod_1.z.string().trim().max(100).optional(),
    tax_id: zod_1.z.string().trim().max(50).optional(),
})
    .strict();
exports.kybScreenCreateProfileSchema = zod_1.z
    .object({
    lookup_id: zod_1.z.number().int().positive(),
    response_id: zod_1.z.number().int().positive(),
})
    .strict();
//# sourceMappingURL=screen.js.map